module.exports = __webpack_public_path__ + "img/theme5.88eee4d9.png";